// extracted by extract-css-chunks-webpack-plugin
module.exports = {"earlyAccessBadge":"earlyAccessBadge_G1oEH","comingSoon":"comingSoon_honlK"};